import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { AddLocalPriceSuggestionPricesTabs } from '@retail/price-suggestion/types';
import { UnderlinedTabs } from '@shared/components';
import { useCallback, useMemo } from 'react';

interface Props {
  selectedTab: AddLocalPriceSuggestionPricesTabs;
  setSelectedTab: (tab: AddLocalPriceSuggestionPricesTabs) => void;
}

export function LocalPriceSuggestionTabs({ selectedTab, setSelectedTab }: Props) {
  const t = useMyAssortmentTFunction();
  const tabs = useMemo(
    () => [
      { label: t('myAssortment.filters.itemSearch'), value: 'ITEM_SEARCH' },
      { label: t('myAssortment.actions.importItems'), value: 'IMPORT' },
    ],
    [t]
  );

  const selectTab = useCallback(
    (_: any, newTab: AddLocalPriceSuggestionPricesTabs) => setSelectedTab(newTab),
    [setSelectedTab]
  );

  return <UnderlinedTabs id="draft" tabs={tabs} currentTab={selectedTab} onChange={selectTab} />;
}
